module.exports = __webpack_public_path__ + "img/overview2.820a9a44.jpg";